import React from 'react';

const ANSWER_TYPE_LABELS = {
  choice: 'choix unique',
  multichoice: 'choix multiple',
  numeric: 'numérique',
  date: 'date',
  text: 'texte',
  unknown: 'autre',
};

// Type badge next to the question selector.
const TypeBadge = ({ answerType }) => {
  const label = ANSWER_TYPE_LABELS[answerType] || ANSWER_TYPE_LABELS.unknown;
  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400">
      {label}
    </span>
  );
};

export default TypeBadge;
